// extracted by mini-css-extract-plugin
export default {"container":"Settings_container__hHTy1","dialogButtons":"Settings_dialogButtons__ooyoi"};